import * as r from "react";
import { useUID as d } from "@twilio-paste/uid-library";
import { IconWrapper as h } from "./helpers/IconWrapper";
const p = r.forwardRef((_ref, c) => {
  let {
    as: l,
    display: i,
    element: t = "ICON",
    size: a,
    color: s,
    title: o,
    decorative: e
  } = _ref;
  const n = "ChevronUpIcon-".concat(d());
  if (!e && o == null) throw new Error("[ChevronUpIcon]: Missing a title for non-decorative icon.");
  return r.createElement(h, {
    as: l,
    display: i,
    element: t,
    size: a,
    color: s,
    ref: c
  }, r.createElement("svg", {
    role: "img",
    "aria-hidden": e,
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    "aria-labelledby": n
  }, o ? r.createElement("title", {
    id: n
  }, o) : null, r.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.293 7.293a1 1 0 011.32-.083l.094.083 3 3a1 1 0 01-1.32 1.497l-.094-.083L10 9.415l-2.293 2.292a1 1 0 01-1.32.083l-.094-.083a1 1 0 01-.083-1.32l.083-.094 3-3z"
  })));
});
p.displayName = "ChevronUpIcon";
export { p as ChevronUpIcon };